import { theme } from '#app/theme/theme.js';
import { type ButtonStyles } from './types.js';

export const buttonStyles: ButtonStyles = {
  V2BrandGreen: {
    default: {
      backgroundColor: theme.colorsV2.green10,
      borderColor: theme.colorsV2.green60,
      color: theme.colorsV2.green60,
    },
    disabled: {
      backgroundColor: theme.colorsV2.green20,
      borderColor: theme.colorsV2.green40,
      color: theme.colorsV2.green40,
    },
    focused: {
      backgroundColor: theme.colorsV2.green20,
      borderColor: theme.colorsV2.green60,
      color: theme.colorsV2.green60,
    },
    hovered: {
      backgroundColor: theme.colorsV2.green20,
      borderColor: theme.colorsV2.green60,
      color: theme.colorsV2.green60,
    },
  },
  V2BrandPurple: {
    default: {
      backgroundColor: `${theme.colorsV2.brandPurple}1A`,
      borderColor: theme.colorsV2.brandPurple,
      color: theme.colorsV2.brandPurple,
    },
    disabled: {
      backgroundColor: `${theme.colorsV2.brandPurple}0D`,
      borderColor: `${theme.colorsV2.brandPurple}B3`,
      color: `${theme.colorsV2.brandPurple}B3`,
    },
    focused: {
      backgroundColor: `${theme.colorsV2.brandPurple}33`,
      borderColor: theme.colorsV2.brandPurple,
      color: theme.colorsV2.brandPurple,
    },
    hovered: {
      backgroundColor: `${theme.colorsV2.brandPurple}33`,
      borderColor: theme.colorsV2.brandPurple,
      color: theme.colorsV2.brandPurple,
    },
  },
  V2BrandPurpleLink: {
    default: {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      color: theme.colorsV2.brandPurple,
    },
    disabled: {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      color: theme.colorsV2.brandPurple,
    },
    focused: {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      color: theme.colorsV2.brandPurple,
    },
    hovered: {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      color: theme.colorsV2.brandPurple,
    },
  },
  V2BrandPurpleSolid: {
    default: {
      backgroundColor: '#6A57E3',
      borderColor: '#6A57E3',
      color: theme.colorsV2.white,
    },
    disabled: {
      backgroundColor: theme.colorsV2.gray20,
      borderColor: theme.colorsV2.gray20,
      color: theme.colorsV2.gray40,
    },
    focused: {
      backgroundColor: '#4D3AC5',
      borderColor: '#4D3AC5',
      color: theme.colorsV2.white,
    },
    hovered: {
      backgroundColor: '#4D3AC5',
      borderColor: '#4D3AC5',
      color: theme.colorsV2.white,
    },
  },
  V2Destructive: {
    default: {
      backgroundColor: theme.colorsV2.red60,
      borderColor: 'transparent',
      color: theme.colorsV2.white,
    },
    disabled: {
      backgroundColor: theme.colorsV2.gray20,
      borderColor: 'transparent',
      color: theme.colorsV2.gray40,
    },
    focused: {
      backgroundColor: theme.colorsV2.red70,
      borderColor: 'transparent',
      color: theme.colorsV2.white,
    },
    hovered: {
      backgroundColor: theme.colorsV2.red70,
      borderColor: 'transparent',
      color: theme.colorsV2.white,
    },
  },
  V2DestructiveLink: {
    default: {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      color: theme.colorsV2.red60,
    },
    disabled: {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      color: theme.colorsV2.gray50,
    },
    focused: {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      color: theme.colorsV2.red70,
    },
    hovered: {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      color: theme.colorsV2.red70,
    },
  },
  V2Download: {
    default: {
      backgroundColor: theme.colorsV2.gray90,
      borderColor: 'transparent',
      color: theme.colorsV2.white,
    },
    disabled: {
      backgroundColor: theme.colorsV2.gray90,
      borderColor: 'transparent',
      color: theme.colorsV2.white,
    },
    focused: {
      backgroundColor: theme.colorsV2.gray80,
      borderColor: 'transparent',
      color: theme.colorsV2.white,
    },
    hovered: {
      backgroundColor: theme.colorsV2.gray80,
      borderColor: 'transparent',
      color: theme.colorsV2.white,
    },
  },
  V2Gradient: {
    default: {
      backgroundColor: theme.colorsV2.gray90,
      borderColor: 'transparent',
      borderWidth: '0px',
      color: theme.colorsV2.white,
    },
    disabled: {
      backgroundColor: theme.colorsV2.gray20,
      borderColor: 'transparent',
      borderWidth: '0px',
      color: theme.colorsV2.gray40,
    },
    focused: {
      backgroundColor: theme.colorsV2.gray80,
      borderColor: 'transparent',
      borderWidth: '0px',
      color: theme.colorsV2.white,
    },
    hovered: {
      backgroundColor: theme.colorsV2.gray80,
      borderColor: 'transparent',
      borderWidth: '0px',
      color: theme.colorsV2.white,
    },
  },
  V2GradientContraPro: {
    default: {
      backgroundColor: theme.colorsV2.gray90,
      borderColor: 'transparent',
      borderWidth: '0px',
      color: theme.colorsV2.white,
    },
    disabled: {
      backgroundColor: theme.colorsV2.gray20,
      borderColor: 'transparent',
      borderWidth: '0px',
      color: theme.colorsV2.gray40,
    },
    focused: {
      backgroundColor: theme.colorsV2.gray80,
      borderColor: 'transparent',
      borderWidth: '0px',
      color: theme.colorsV2.white,
    },
    hovered: {
      backgroundColor: theme.colorsV2.gray80,
      borderColor: 'transparent',
      borderWidth: '0px',
      color: theme.colorsV2.white,
    },
  },
  V2Link: {
    default: {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      color: theme.colorsV2.black,
    },
    disabled: {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      color: theme.colorsV2.gray50,
    },
    focused: {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      color: theme.colorsV2.black,
    },
    hovered: {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      color: theme.colorsV2.black,
    },
  },
  V2Primary: {
    default: {
      backgroundColor: theme.colorsV2.gray90,
      borderColor: 'transparent',
      color: theme.colorsV2.white,
    },
    disabled: {
      backgroundColor: theme.colorsV2.gray20,
      borderColor: 'transparent',
      color: theme.colorsV2.gray40,
    },
    focused: {
      backgroundColor: theme.colorsV2.gray80,
      borderColor: 'transparent',
      color: theme.colorsV2.white,
    },
    hovered: {
      backgroundColor: theme.colorsV2.gray80,
      borderColor: 'transparent',
      color: theme.colorsV2.white,
    },
  },
  V2Secondary: {
    default: {
      backgroundColor: theme.colorsV2.white,
      borderColor: theme.colorsV2.gray80,
      color: theme.colorsV2.gray80,
    },
    disabled: {
      backgroundColor: theme.colorsV2.gray20,
      borderColor: 'transparent',
      color: theme.colorsV2.gray40,
    },
    focused: {
      backgroundColor: theme.colorsV2.gray10,
      borderColor: theme.colorsV2.gray80,
      color: theme.colorsV2.gray80,
    },
    hovered: {
      backgroundColor: theme.colorsV2.gray10,
      borderColor: theme.colorsV2.gray80,
      color: theme.colorsV2.gray80,
    },
  },
  V2TertiaryOutline: {
    default: {
      backgroundColor: theme.colorsV2.white,
      borderColor: theme.colorsV2.gray40,
      color: theme.colorsV2.gray80,
    },
    disabled: {
      backgroundColor: theme.colorsV2.gray20,
      borderColor: 'transparent',
      color: theme.colorsV2.gray40,
    },
    focused: {
      backgroundColor: theme.colorsV2.gray10,
      borderColor: theme.colorsV2.gray40,
      color: theme.colorsV2.gray80,
    },
    hovered: {
      backgroundColor: theme.colorsV2.gray10,
      borderColor: theme.colorsV2.gray40,
      color: theme.colorsV2.gray80,
    },
  },
  V2TertiarySolid: {
    default: {
      backgroundColor: theme.colorsV2.gray10,
      borderColor: 'transparent',
      color: theme.colorsV2.gray80,
    },
    disabled: {
      backgroundColor: theme.colorsV2.gray20,
      borderColor: 'transparent',
      color: theme.colorsV2.gray40,
    },
    focused: {
      backgroundColor: theme.colorsV2.gray10,
      borderColor: theme.colorsV2.gray30,
      color: theme.colorsV2.gray80,
    },
    hovered: {
      backgroundColor: theme.colorsV2.gray10,
      borderColor: theme.colorsV2.gray30,
      color: theme.colorsV2.gray80,
    },
  },
};
